import React from 'react';
import {Image, Platform, Text, TouchableOpacity, View} from 'react-native';
import {
   white,
   FONT_FAMILY_REGULAR,
   isNewAPI,
   listItemBG,
   isHoverEnabled,
   LIST_HOVER_COLOR,
} from '../../utils/utils';

const ModuleItems = ({props}) => {
   const [isHover, setHover] = React.useState(false);
   return (
      <View
         onMouseEnter={() => {
            setHover(true);
         }}
         onMouseLeave={() => {
            setHover(false);
         }}
         style={{
            flexDirection: 'row',
            backgroundColor:
               isHover && isHoverEnabled ? LIST_HOVER_COLOR : listItemBG,
            borderRadius: 4,
            marginTop: 8,
            marginHorizontal: 12,
            paddingVertical: 12,
            paddingHorizontal: 16,
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            ...Platform.select({
               web: {
                  marginTop: 0,
                  marginBottom: 8,
               },
            }),
         }}>
         <Text
            style={{
               flex: 1,
               fontSize: 12,
               marginEnd: 10,
               color: '#000000',
               fontFamily: FONT_FAMILY_REGULAR,
               fontWeight: '600',
            }}>
            {isNewAPI ? props.item.ModuleDescription : props.item.ModuleName}
         </Text>
         <View
            style={{
               height: 20,
               width: 2,
               borderRadius: 2,
               opacity: 0.1,
               backgroundColor: '#000000',
            }}
         />
         <Text
            style={{
               width: 50,
               fontSize: 16,
               textAlign: 'right',
               color: '#2B3241',
               fontFamily: FONT_FAMILY_REGULAR,
               fontWeight: '600',
            }}>
            {isNewAPI ? props.item.TestQuestionScore : props.item.TestResult}
         </Text>
      </View>
   );
};

export default ModuleItems;
